// Centralised TanStack Query keys. Invalidating a high-level key (e.g. ["units"])
// invalidates every nested key, which keeps mutation -> refresh chains short.

export const qk = {
  auth: ["auth"] as const,
  whoami: () => [...qk.auth, "whoami"] as const,

  unitTypes: ["unit-types"] as const,
  unitType: (id: string) => [...qk.unitTypes, id] as const,

  cms: ["cms"] as const,
  cm: (id: string) => [...qk.cms, id] as const,

  tokens: ["tokens"] as const,
  token: (id: string) => [...qk.tokens, id] as const,

  audit: (q: Record<string, unknown>) => ["audit", q] as const,

  dashboard: ["dashboard"] as const,

  mac: ["mac"] as const,
  macNamespaces: () => [...qk.mac, "namespaces"] as const,
  macNamespace: (code: string) => [...qk.macNamespaces(), code] as const,
  macSearch: (code: string, q: Record<string, unknown>) =>
    [...qk.macNamespace(code), "search", q] as const,
  macValue: (code: string, value: string) =>
    [...qk.macNamespace(code), "values", value] as const,

  usbpid: ["usbpid"] as const,
  usbpidNamespaces: () => [...qk.usbpid, "namespaces"] as const,
  usbpidNamespace: (code: string) => [...qk.usbpidNamespaces(), code] as const,
  usbpidSearch: (code: string, q: Record<string, unknown>) =>
    [...qk.usbpidNamespace(code), "search", q] as const,
  usbpidValue: (code: string, value: string) =>
    [...qk.usbpidNamespace(code), "values", value] as const,

  imei: ["imei"] as const,
  imeiNamespaces: () => [...qk.imei, "namespaces"] as const,
  imeiNamespace: (code: string) => [...qk.imeiNamespaces(), code] as const,
  imeiSearch: (code: string, q: Record<string, unknown>) =>
    [...qk.imeiNamespace(code), "search", q] as const,
  imeiValue: (code: string, value: string) =>
    [...qk.imeiNamespace(code), "values", value] as const,

  units: ["units"] as const,
  unitSchemas: () => [...qk.units, "schemas"] as const,
  unitSchema: (code: string) => [...qk.unitSchemas(), code] as const,
  unitSearch: (code: string, q: Record<string, unknown>) =>
    [...qk.unitSchema(code), "search", q] as const,
  unitValue: (code: string, value: string) =>
    [...qk.unitSchema(code), "values", value] as const,
  unitCompliance: (code: string, value: string) =>
    [...qk.unitValue(code, value), "compliance"] as const,
  unitLinks: (code: string, value: string) =>
    [...qk.unitValue(code, value), "links"] as const,
  unitByLink: (cls: string, value: string) =>
    [...qk.units, "by-link", cls, value] as const,
  unitBom: (code: string, value: string, opts: { recursive?: boolean; includeRemoved?: boolean }) =>
    [...qk.unitValue(code, value), "bom", opts] as const,
  unitParents: (code: string, value: string) =>
    [...qk.unitValue(code, value), "parents"] as const,
} as const;
